module.exports = __webpack_public_path__ + "img/battery_4blue.41491ac9.png";